import { ContentViewModel } from '@levelapp/softfabric';
import { Animated } from 'react-native';
export default class SliderViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        this.initialState({ sliderValue: this.props().defaultValue, transformX: new Animated.Value(0) });
        this.handleSliderReleased = this.handleSliderReleased.bind(this);
        this.handleSliderValueChange = this.handleSliderValueChange.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }
    handleReset() {
        if (this.props().resetValue != undefined && this.props().resetValue) {
            this.setField({ sliderValue: this.props().defaultValue });
            this.slider.setNativeProps({ value: this.props().defaultValue });
        }
    }
    handleSliderReleased(value) {
        this.onRelease(value);
    }
    handleSliderValueChange(value) {
        this.setField({ sliderValue: value });
    }
    onRelease(value) {
        this.props().onRelease != undefined && this.props().onRelease(value);
    }
}
